// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React from 'react'
import pickBy from 'lodash/pickBy'
import {
  DAYS,
  EVENT_TYPES,
  EVENT_TYPES_VALUES,
  EVENT_TYPES_VALUES_LOGS,
  MONTHNAME,
  MONTH_NAMES,
  validCard,
  validPassword,
  validPhone,
} from '../constants/globalConstants'
import moment from 'moment'
import { getConfigDetails } from '../services/config'
import Resizer from 'react-image-file-resizer'
import master from '../assets/img/mastercard.png'
import visa from '../assets/img/visa.png'
import discover from '../assets/img/discover_card.png'
import diner from '../assets/img/diners_card.png'
import amex from '../assets/img/amax_card.png'
import jcb from '../assets/img/jcb_hr.png'
import blank from '../assets/img/blank_credit_card.png'
import masterimg from '../assets/img/master_img.png'
import parkingpayments from '../assets/img/parkingpayments.png'
import townsend from '../assets/img/townsend.png'
import jordanImage from '../assets/img/intrapark_blue1bg.png'
import logos from '../assets/img/logos.svg'
import { STORAGE_KEY } from '../constants'
import CryptoJS from 'crypto-js'
import { toast } from 'react-toastify'
import $ from 'jquery'

import gpl from '../assets/img/google_pay.png'
import apl from '../assets/img/apple_pay.png'
import { useLocation } from 'react-router-dom'
import SimpleReactValidator from 'simple-react-validator'


let userAgent = navigator.userAgent || navigator.vendor
export const iOS = (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  ? true : false

//   Sat Apr 01 2023 17:05:00 GMT+0530 (India Standard Time)
export const formatDate = (date) => {
  let date_final
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final = MONTH_NAMES[newDate.getMonth()] + ' ' + newDate.getDate()
  } else {
    let format_date = new Date(date)
    date_final =
      MONTH_NAMES[format_date.getMonth()] + ' ' + format_date.getDate()
  }
  return date_final
}

export const formatDateDays = (date) => {
  let date_final
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final = DAYS[newDate.getDay()]
  } else {
    let format_date = new Date(date)
    date_final = DAYS[format_date.getDay()]
  }
  return date_final
}

export const formatAMPM = (date) => {
  let strTime
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    let hours = newDate.getHours()
    let minutes = newDate.getMinutes()
    let ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes ? (minutes < 10 ? '0' + minutes : minutes) : '00'
    strTime = hours + ':' + minutes + ' ' + ampm
  } else {
    let hours = new Date(date).getHours()
    let minutes = new Date(date).getMinutes()
    let ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes ? (minutes < 10 ? '0' + minutes : minutes) : '00'
    strTime = hours + ':' + minutes + ' ' + ampm
  }
  return strTime
}

export const dateFormatter = (date, format) => moment(date).format(format)
// export const dateFormatterMonth = (date, format) => moment(date).format(format)

export function formatMonthYear(date) {
  let date_final
  if (iOS) {
    let arr = date.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final =
      MONTHNAME[newDate.getMonth()] + ' ' + newDate.getFullYear()
  } else {
    let format_date = new Date(date)
    date_final =
      MONTHNAME[format_date.getMonth()] + ' ' + format_date.getFullYear()
  }

  return date_final
}



export const getEventType = (event) => {
  switch (event) {
    case EVENT_TYPES.EVENT:
      return EVENT_TYPES_VALUES.EVENT
    case EVENT_TYPES.BUNDLE_PASS:
      return EVENT_TYPES_VALUES.BUNDLE_PASS
    case EVENT_TYPES.PARTY_PASS:
      return EVENT_TYPES_VALUES.PARTY_PASS
    case EVENT_TYPES.SIMPLE:
      return EVENT_TYPES_VALUES.SIMPLE
    default:
      return EVENT_TYPES_VALUES.EVENT
  }
}
// export const getEventTypeById = (event_id, log) => {
//   switch (event_id) {
//     case `${getConfigDetails().FULL_SEASON}`:
//       return log ? EVENT_TYPES_VALUES_LOGS.BUNDLE_PASS : EVENT_TYPES_VALUES.BUNDLE_PASS
//     case `${getConfigDetails().HALF_SEASON}`:
//       return  log ? EVENT_TYPES_VALUES_LOGS.PARTY_PASS : EVENT_TYPES_VALUES.PARTY_PASS
//     case `${getConfigDetails().SIX_PACK}`:
//       return log ? EVENT_TYPES_VALUES_LOGS.SIMPLE : EVENT_TYPES_VALUES.SIMPLE
//     default:
//       return log ? EVENT_TYPES_VALUES_LOGS.EVENT : EVENT_TYPES_VALUES.EVENT
//   }
// }

export const getEventTypeByPassType = (pass_type, is_full_season, log) => {
  // switch (event_id) {
  if (pass_type == EVENT_TYPES?.BUNDLE_PASS && is_full_season == 1) {
    return log ? EVENT_TYPES_VALUES_LOGS.BUNDLE_PASS : EVENT_TYPES_VALUES.BUNDLE_PASS
  } else if (pass_type == EVENT_TYPES?.BUNDLE_PASS && is_full_season != 1) {
    return log ? EVENT_TYPES_VALUES_LOGS.PARTY_PASS : EVENT_TYPES_VALUES.PARTY_PASS
  } else if (pass_type == EVENT_TYPES?.PARTY_PASS) {
    return log ? EVENT_TYPES_VALUES_LOGS.SIMPLE : EVENT_TYPES_VALUES.SIMPLE
  } else {
    return log ? EVENT_TYPES_VALUES_LOGS.EVENT : EVENT_TYPES_VALUES.EVENT
  }
}

export const getEventCount = (eventId) => {
  // const halfSeasonEvents = localStorage.getItem('userChooseEvents')
  const eventDetails = JSON.parse(localStorage.getItem(EVENT_TYPES?.EVENT))

  switch (eventId) {
    case getConfigDetails?.HALF_SEASON:
      return eventDetails?.all_event?.length / 2
    case getConfigDetails?.FULL_SEASON:
      return eventDetails?.all_event?.length
    case getConfigDetails?.SIX_PACK:
      return 6
    default:
      return 1
  }
}

export const getSanitizedValues = (values) =>
  pickBy(values, (value) => {
    const expression = !(
      value === 0 ||
      value === '' ||
      value === undefined ||
      value === null ||
      Number.isNaN(value) ||
      value?.length === 0
    )
    return expression
  })

export const trimedSpacePayload = (input) => {
  if (typeof input === 'string') {
    return input.trim()
  } else if (Array.isArray(input)) {
    return input.map(trimedSpacePayload)
  } else if (typeof input === 'object' && input !== null) {
    const trimmedObj = {}
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        trimmedObj[key] = trimedSpacePayload(input[key])
      }
    }
    return trimmedObj
  }
  return input
}

const setLocalStorage = (userData) => {
  userData.map((data) => {
    localStorage.setItem(data.key, data.value)
  })
}

export const getLoginDetailFromSession = () =>
  localStorage.getItem(STORAGE_KEY.ACCESS_TOKEN)

export const getBearerToken = () => localStorage.getItem(STORAGE_KEY.ID_TOKEN)

export const setLoginDetailInSession = (loggedInUserData) => {
  const userData = [
    {
      key: STORAGE_KEY.ACCESS_TOKEN,
      value: loggedInUserData?.AccessToken,
    },
    {
      key: STORAGE_KEY.REFRESH_TOKEN,
      value: loggedInUserData?.RefreshToken,
    },
    {
      key: STORAGE_KEY.ID_TOKEN,
      value: loggedInUserData?.IdToken,
    },
    {
      key: STORAGE_KEY.TOKEN_TYPE,
      value: loggedInUserData?.TokenType,
    },
  ]
  setLocalStorage(userData)
}

export function isLoggedIn() {
  const userDataFromStorage = localStorage.getItem('userData') ? localStorage.getItem('userData') : '{}'
  const userData = JSON.parse(userDataFromStorage)
  const access_token = userData?.access_token
  if (access_token && access_token != '') {
    return true
  } else {
    return false
  }
}

export function isArrayWithLength(arr) {
  return Array.isArray(arr) && arr.length
}

export function getAllowedRoutes(routes) {
  const role = localStorage.getItem('userRole')
  return routes.filter(({ permission }) => {
    if (!permission) return true
    else if (!isArrayWithLength(permission)) return true
    else return permission.indexOf(role) !== -1
  })
}

export function classes() {
  return [...arguments].join(' ')
}

export const clearSessionDetails = () => {
  localStorage.clear()
}

export const restrictInputValues = (event) => {
  if (!`${event.target.value}${event.key}`.match(/^[0-9]{0,6}$/)) {
    // block the input if result does not match
    event.preventDefault()
    event.stopPropagation()
    return false
  }
}

export const numberMobile = (e) => {
  e.target.value = e.target.value.replace(/[^\d]/g, '')
  return false
}

export const restrictInputValuesVal = (event) => {
  if (!`${event.target.value}`.match(/^[0-9]{0,6}$/)) {
    // block the input if result does not match
    event.preventDefault()
    event.stopPropagation()
    return false
  } else {
    return true
  }

}

// export const restrictSpecialChar = (e) => {
//   const result = (e.key == '!' || e.key == '@' || e.key == '#' || e.key == '$' || e.key == '%' || e.key == '^'
//     || e.key == '&' || e.key == '~' || e.key == '`' || e.key == '*' || e.key == '(' || e.key == ')' || e.key == '_'
//     || e.key == '=' || e.key == '+' || e.key == '[' || e.key == ']' || e.key == '{' || e.key == '}' || e.keyCode == 220
//     || e.key == '|' || e.key == ':' || e.key == ';' || e.keyCode == 222 || e.key == ' ' || e.key == '?' || e.key == '.' || e.key == ',' || e.key == '>' || e.key == '<')
//   if (result) {
//     e.preventDefault()
//   } else {
//     return result
//   }
// }

export const restrictSpecialChar = (e, allowSpaceHyphenFields = []) => {
  // List of restricted characters excluding numbers, alphabets, space, and hyphen
  const restrictedChars = [
    '!', '@', '#', '$', '%', '^', '&', '~', '`', '*', '(', ')', '_', '=', '+',
    '[', ']', '{', '}', '\\', '|', ':', ';', '"', "'", '?', '.', ',', '>', '<'
  ]

  // Check if the current field is in the allowed fields array
  const isAllowedField = allowSpaceHyphenFields.includes(e.target.name)

  // Check if the pressed key is restricted
  const isRestricted = restrictedChars.includes(e.key) || e.keyCode === 220 || e.keyCode === 222

  // If it's a restricted character, or it's a space/hyphen in a field that's not allowed, prevent the input
  if (isRestricted || (!isAllowedField && (e.key === ' ' || e.key === '-'))) {
    e.preventDefault()
  }
}

export const getEventLogName = (pass_type, is_full_season) => `MAPCO - BOOK NOW - ${getEventTypeByPassType(pass_type, is_full_season, 'log')}`


// export const validateEmail = (email) => {
//   // eslint-disable-next-line no-useless-escape
//   let pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/

//   return pattern.test(email)
// }
export const isValidEmail = (email, object) => {
  let domainValidation = object?.email_domain_validation
  let AllowDomainValidation = object?.email_domain

  if (domainValidation == 1) {
    const allowedDomains = (AllowDomainValidation || '@maine.edu')
      .toLowerCase()
      .split(',')
      .map(d => d.replace(/^@/, '').trim()) // remove leading @

    // Extract domain from email
    const emailDomain = email.split('@')[1]?.toLowerCase()
    return allowedDomains.includes(emailDomain)
  }
  return true
}

export const validateEmail = (email, emailValidationCheck = {}, nextObject = {}) => {
  // Basic email pattern
  const pattern = /^[A-Z0-9._%+-]+@[A-Z0-9-]+(?!.*?[.]{2})[A-Z0-9.-]+\.[A-Z]{2,}$/i   //USM-155
  // let pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/   //old code
  // let pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/
  const valid = pattern.test(email)

  if (!valid) return false

  // Domain validation
  let domainValidation = nextObject?.email_domain_validation ? nextObject?.email_domain_validation : emailValidationCheck?.email_domain_validation
  let AllowDomainValidation = nextObject?.email_domain ? nextObject?.email_domain : emailValidationCheck?.email_domain

  if (domainValidation == 1) {
    // Get allowed domains (comma separated → array)
    const allowedDomains = (AllowDomainValidation || '@maine.edu')
      .toLowerCase()
      .split(',')
      .map(d => d.replace(/^@/, '').trim()) // remove leading @

    // Extract domain from email
    const emailDomain = email.split('@')[1]?.toLowerCase()

    // console.log('allowedDomains', allowedDomains)
    // console.log('emailDomain', emailDomain)

    if (allowedDomains.includes(emailDomain)) {
      return true
    }

    // Try next object if provided
    return isValidEmail(email, nextObject)
  }

  return isValidEmail(email, nextObject)
}



export const validatePhone = (phone) => {
  // eslint-disable-next-line no-useless-escape
  return validPhone.test(phone)
}

export const restrictInValidCharPassword = (value = '') => {
  // List of restricted characters
  // const restrictedChars = /[()\\`~:;"/<>]/g
  const restrictedChars = /[^!@#$%^&*?\w\s-]/g

  // Remove restricted characters from the input value
  let filteredValue = value?.replace(restrictedChars, '')
  filteredValue = filteredValue?.replace('_', '')
  return filteredValue
}

export const restrictInValidCharLicense = (value = '') => {
  // Allow only A–Z, a–z, 0–9
  const restrictedChars = /[^a-zA-Z0-9]/g

  return value.replace(restrictedChars, '')
}

export const restrictLeadingTrailingSpace = (value = '') => {
  // If the input is only spaces, set it to an empty string
  if (!value?.trim()) {
    value = ''  // Prevent only spaces from being entered
  } else {
    value = value?.replace(/\s\s+/g, ' ')  // Replace multiple spaces with a single space between characters
  }
  return value
}

export const handleKeyPressRestrictLeadingTrailingSpace = (e, restrictAllSpace = false) => {
  const value = e.target.value
  const char = e.key

  if (restrictAllSpace && char === ' ') {
    e.preventDefault()
    return
  }

  if (char === ' ') {
    // Prevent first character being a space (before any char is typed)
    if (value.trim() === '') {
      e.preventDefault()
      return
    }
    // Prevent space at first position (if value exists but cursor is at start)
    if (e.target.selectionStart === 0) {
      e.preventDefault()
      return
    }
    // Prevent multiple consecutive spaces
    if (value[value.length - 1] === ' ') {
      e.preventDefault()
      return
    }
  }
}


export const validatePassword = (pwd) => {
  // eslint-disable-next-line no-useless-escape
  return validPassword.test(pwd)
}
export const matchPassword = (pwd, cpwd) => {
  // eslint-disable-next-line no-useless-escape
  return pwd == cpwd
}

export const validateCardNumber = (card) => {
  // eslint-disable-next-line no-useless-escape
  return validCard.test(card)
}

export const fileChangedHandler = (event, fileId, setIdProof, idProof, fileWidth, fileHeight, setIdErrProof) => {
  let fileInput = false
  let file = document.getElementById(fileId).files[0]

  fileInput = file && (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif')
  if (fileInput) {
    try {
      Resizer.imageFileResizer(
        file,
        fileWidth,
        fileHeight,
        'PNG', // fileType(JPEG, PNG,WEBP)
        100,  // quality compression(for jpeg)
        0, // rotation(0-100)
        (uri) => {
          new Promise((resolve, reject) => {
            const img = new Image()
            // the following handler will fire after a successful loading of the image
            img.onload = () => {
              const { naturalWidth: width, naturalHeight: height } = img
              resolve({ width, height })
              if (fileId == 'front') {
                setIdProof({ ...idProof, ...{ ['front']: uri } })
                setIdErrProof({ ...idProof, ...{ ['front']: uri } })
              } else {
                setIdProof({ ...idProof, ...{ ['back']: uri } })
                setIdErrProof({ ...idProof, ...{ ['back']: uri } })
              }
            }
            // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
            img.onerror = () => {
              reject('There was some problem with the image.')
            }
            img.src = URL.createObjectURL(uri)
          })
        },
        'file' // outputType( base64, blob or file)
      )
    } catch (err) {
      // setIdProof({fileId : ''})
    }
  } else {
    // setIdProof({fileId : ''})
  }
}

const checkCurrentFileAcceptance = (file = {}, typeList = '') => {
  if (typeList.toLocaleLowerCase() == 'pdf' && file.type === 'application/pdf') {
    return true
  } else if (typeList.toLocaleLowerCase() == 'csv' && file.type === 'text/csv') {
    return true
  } else if (typeList.toLocaleLowerCase() == 'image,pdf' && file.type === 'application/pdf') {
    return true
  } else if (typeList.toLocaleLowerCase() == 'image,pdf,doc' && (file.type === 'application/pdf' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/msword')) {
    return true
  } else if (typeList.toLocaleLowerCase() == 'all' && (file.type === 'application/vnd.ms-excel' || file.type === 'text/csv' || file.type === 'application/pdf' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/msword')) {
    return true
  } else {
    return false
  }
}

export const multiFileChangedHandler = (event, fileId, setIdProof, idProof, fileWidth, fileHeight, notify, fileSizeLimit, typeList) => {
  let fileInput = false
  let file = document.getElementById(fileId).files[0]
  const selectedIdProof = idProof?.filter((item) => item?.type == fileId)
  const filterIdProof = idProof?.filter((item) => item?.type != fileId)

  let flag = false
  idProof.map((item) => {
    if (item?.file?.name.toLowerCase() == file?.name.toLowerCase()) {
      flag = true
    }
  })

  if (flag) {
    notify('error', 'Please select a different document.')
    $('.custom-file-label-logo').html('')
    document.getElementById(fileId).value = ''
    return
  }

  if (file?.size <= fileSizeLimit * (1048576)) {
    fileInput = file && (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')
    if (fileInput) {
      try {
        Resizer.imageFileResizer(
          file,
          fileWidth,
          fileHeight,
          file.type == 'image/jpeg' || file.type == 'image/jpg' ? 'JPG' : 'PNG', // fileType(JPEG, PNG,WEBP)
          0,  // quality compression(for jpeg)
          0, // rotation(0-100)
          (uri) => {
            new Promise((resolve, reject) => {
              const img = new Image()
              // the following handler will fire after a successful loading of the image
              img.onload = () => {
                const { naturalWidth: width, naturalHeight: height } = img
                resolve({ width, height })
                if (fileId) {
                  const newFile = {
                    type: fileId,
                    file: uri
                  }
                  if (selectedIdProof?.length < 1 && uri) {
                    setIdProof([...idProof, newFile])
                  } else {
                    if (uri) {
                      setIdProof([...filterIdProof, newFile])
                    }
                  }
                  $('.custom-file-label-logo').html('')
                  document.getElementById(fileId).value = ''
                }
                // if (fileId == 'front') {
                //   setIdProof({ ...idProof, ...{ ['front']: uri } })
                //   setIdErrProof({ ...idProof, ...{ ['front']: uri } })
                // } else {
                //   setIdProof({ ...idProof, ...{ ['back']: uri } })
                //   setIdErrProof({ ...idProof, ...{ ['back']: uri } })
                // }
              }
              // and this handler will fire if there was an error with the image (like if it's not really an image or a corrupted one)
              img.onerror = () => {
                $('.custom-file-label-logo').html('')
                document.getElementById(fileId).value = ''
                reject('There was some problem with the image.')
              }
              img.src = URL?.createObjectURL(uri)
            })
          },
          'file' // outputType( base64, blob or file)
        )
      } catch (err) {
        // setIdProof({fileId : ''})
      }
    } else if (file && checkCurrentFileAcceptance(file, typeList)) {
      const newFile = {
        type: fileId,
        file: file
      }
      if (selectedIdProof?.length < 1 && file) {
        setIdProof([...idProof, newFile])
      } else {
        if (file) {
          setIdProof([...filterIdProof, newFile])
        }
      }
      $('.custom-file-label-logo').html('')
      document.getElementById(fileId).value = ''
    } else {
      $('.custom-file-label-logo').html('')
      document.getElementById(fileId).value = ''
      notify('error', 'Selected Document is not Valid')
    }
  } else {
    $('.custom-file-label-logo').html('')
    document.getElementById(fileId).value = ''
    notify('error', 'Maximum File Size Exceeded')
  }

}

export const encryptionHandler = (d) => {
  var nonceString = d.name_on_card + ':' + d.card_number + ':' + d.expiration_date + ':' + d.security_code + ':' + d.zip_code
  var CryptoJSAesJson = {
    stringify: function (cipherParams) {
      var j = {
        ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
        iv: '',
        s: ''
      }
      if (cipherParams.iv)
        j.iv = cipherParams.iv.toString()
      if (cipherParams.salt)
        j.s = cipherParams.salt.toString()
      return JSON.stringify(j)
    },
    parse: function (jsonStr) {
      var j = JSON.parse(jsonStr)
      var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
      if (j.iv)
        cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s)
        cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams
    }
  }
  var encrypted = CryptoJS.AES.encrypt(JSON.stringify(nonceString), 'Tw5qNOJLe5GFe7rjFsentNNQBsRHstbNzTP/18lkjnY=', { format: CryptoJSAesJson }).toString()
  return encrypted
}


export const formattedExpiry = (expiry) => {
  return expiry.slice(0, 2) + '/' + expiry.slice(2)
}

export const formatYearMonthExpiry = (value) => {
  if (value === null || value === undefined) return ''

  let str = String(value).trim()

  // Keep only digits
  str = str.replace(/\D/g, '')

  // Handle 5-digit case (YYYYM)
  if (str.length === 5) {
    const year = str.slice(0, 4)
    const month = str.slice(4)
    return `${year}/0${month}`
  }

  // Handle 6-digit case (YYYYMM)
  if (str.length === 6) {
    const year = str.slice(0, 4)
    const month = str.slice(4)
    return `${year}/${month}`
  }

  return ''
}

export const loggedInUserData = () => {
  const userData = JSON.parse(localStorage.getItem('userData') ? localStorage.getItem('userData') : '{}')
  return userData
}

export const isPartnerTownsend = (partnerSlug) => {
  if (partnerSlug == 'townsend') return true
  return false
}

export const isPartnerWorldPort = (partnerSlug) => {
  if (partnerSlug == 'worldport-la') return true
  return false
}

export const getLocation = (faciltyData) => {
  const location = faciltyData?.geolocations
  return `https://www.google.com/maps?daddr=${location?.latitude},${location?.longitude}+(${faciltyData?.full_name?.replace(/ /g, '+')})`
}

export const getPartnerDetails = () => {
  const partner = (localStorage.getItem('partnerData') && localStorage.getItem('partnerData') != 'undefined') ? JSON.parse(localStorage.getItem('partnerData')) : (sessionStorage.getItem('partnerData') && sessionStorage.getItem('partnerData') != 'undefined') ? JSON.parse(sessionStorage.getItem('partnerData')) : {}
  return partner
}

export const priceGreaterOrNot = (ticketDetails) => {
  const paymentDataKeys = ['parking_amount', 'amount_paid', 'processing_fee', 'tax_rate', 'payable_amount', 'grand_total', 'discount_amount', 'paid_amount']
  let isGreaterOrNot = paymentDataKeys.map((key) => {
    if ((ticketDetails?.[key] && Number(ticketDetails?.[key]) > 0)) {
      return true
    } else {
      return false
    }
  })
  if (isGreaterOrNot.includes(true)) {
    return true
  }
}

export const getErrorMessage = (response) => {
  let errorMsg = 'Sorry! something went wrong, please try again.'
  const errorsList = response.errors
  if (errorsList.message !== 'Validation Errors') {
    errorMsg = errorsList.message
  } else {
    for (const key in errorsList.detail) {
      if (Object.prototype.hasOwnProperty.call(errorsList.detail, key)) {
        if (typeof errorsList.detail === 'undefined') {
          errorMsg = errorsList.message
        } else {
          errorMsg = Array.isArray(errorsList.detail[key]) ? errorsList.detail[key][0] : errorsList.detail[key]
        }
      }
    }
  }

  return errorMsg
}
export const EncryptionHandler = (d) => {
  var nonceString = d.name_on_card + ':' + d.card_number + ':' + d.expiration_date + ':' + d.security_code + ':' + d.zip_code
  var CryptoJSAesJson = {
    stringify: function (cipherParams) {
      var j = {
        ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64),
        iv: '',
        s: ''
      }
      if (cipherParams.iv)
        j.iv = cipherParams.iv.toString()
      if (cipherParams.salt)
        j.s = cipherParams.salt.toString()
      return JSON.stringify(j)
    },
    parse: function (jsonStr) {
      var j = JSON.parse(jsonStr)
      var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) })
      if (j.iv)
        cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s)
        cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams
    }
  }
  var encrypted = CryptoJS.AES.encrypt(JSON.stringify(nonceString), 'Tw5qNOJLe5GFe7rjFsentNNQBsRHstbNzTP/18lkjnY=', { format: CryptoJSAesJson }).toString()
  return encrypted
}


export const isNotUrl = (partnerslug) => {
  if (partnerslug != 'book-reservation' && partnerslug != 'pass-create' && partnerslug != 'booking') {
    return true
  } else {
    return false
  }
}

export const getPartnerLogo = (name) => {

  const patnerName = name?.toLowerCase()
  switch (patnerName) {

    case 'parkingpayments':
      return parkingpayments
    case 'townsend':
      return townsend
    case 'demoparkengage':
      return logos
    case 'intrapark':
      return jordanImage

    default:
      return logos
  }
}

export const getPartnerTagline = (name) => {

  const patnerName = name?.toLowerCase()
  switch (patnerName) {

    case 'parkingpayments':
      return 'Parking Payments'
    case 'townsend':
      return 'PCI Townsend Parking'
    case 'demoparkengage':
      return 'Parkengage Parking'
    case 'intrapark':
      return 'IntraPark Parking'
    default:
      return 'Parkengage Parking'
  }
}


// export function sortPortalPermissionByKey(partnerDetails, sectionName) {
//   return partnerDetails?.customer_portal_permission?.[sectionName]?.map((item) => item)
// }

export function sortPortalPermissionByKey(partnerDetails, sectionNames) {
  const sectionArray = Array.isArray(sectionNames) ? sectionNames : [sectionNames]

  return sectionArray.reduce((acc, sectionName) => {
    if (partnerDetails?.customer_portal_permission?.[sectionName]) {
      acc.push(...partnerDetails.customer_portal_permission[sectionName].map((item) => item))
    }
    return acc
  }, [])
}


export const isPermissionExist = (data, itemName) => {
  const filterObj = (data?.length > 0) && data?.filter((item) => item?.display_name == itemName)
  if (filterObj[0]?.is_default == '1') {
    return true
  } else {
    return false
  }
}

export const removeObjectsWithEmptyValues = (arr, key) => {
  return arr.filter(obj => obj[key] !== '')
}

export const getFacilityOpenDays = (data) => {
  let result
  const daysToCheck = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
  const MondayToFriday = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
  const keysWithValueOne = daysToCheck.filter(day => data[day] === '1')
  if (keysWithValueOne?.length == 7) {
    result = null
  } else if (areAllElementsPresent(MondayToFriday, keysWithValueOne)) {
    result = 'Monday-Friday'
  } else if (keysWithValueOne?.length > 0) {
    result = keysWithValueOne?.map((item, index) => {
      if (index != (keysWithValueOne?.length - 1)) {
        return nameUpperCase(item) + ', '
      } else {
        return nameUpperCase(item)
      }
    })
  } else {
    result = null
  }
  return result
}

export const areAllElementsPresent = (arr1, arr2) => {
  return arr1.every(function (element) {
    return arr2.includes(element)
  })
}

export const nameUpperCase = (nameString) => {
  const arr = nameString.split('_')
  for (var i = 0; i < arr.length; i++) { arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1) }
  let finalName = arr.join(' ')
  return finalName
}

export const changeTimeZone = (date, timeZone) => {
  if (typeof date === 'string') {
    return new Date(
      new Date(date).toLocaleString('en-US', {
        timeZone,
      }),
    )
  }

  return new Date(
    date.toLocaleString('en-US', {
      timeZone,
    }),
  )
}

export const isPathValid = (array, path) => {
  if (path && path != undefined && path != null && isNaN(path) && path != 'user-profile' && path != 'user' && path != 'permittype2' && path != 'account' && path != 'login' && path != 'find-reservation') {
    return array?.some(obj => obj.web == `/${path}`)
  } else {
    return true
  }

}

export const nextDayCheck = (endTime) => {
  if (endTime == undefined || endTime == '')
    return ''
  let timestamp = endTime.split(':')
  return (timestamp[0] > 24 ? '(next day)' : '')

}

export const HorurCheck = (endTime) => {
  if (endTime == undefined || endTime == '')
    return ''

  let timestamp = endTime.split(':')
  timestamp[0] = timestamp[0] > 24 ? (timestamp[0] - 24).toString() > 9 ? (timestamp[0] - 24).toString() : '0' + (timestamp[0] - 24).toString() : timestamp[0]
  let result = timestamp.join(':')
  return result
}

export const getFormattedTime = (totalhours, isConvert) => {

  const splittedTime = totalhours?.split('.')
  let minutes
  if (isConvert) {
    minutes = (splittedTime?.[1] / 100) * 60
  } else {
    minutes = splittedTime?.[1]
  }
  const hours = splittedTime ? `${splittedTime?.[0] == 0 ? '00' : splittedTime?.[0] == 0 ? '00' : Number(splittedTime?.[0]) < 10 ? `0${splittedTime?.[0]} ` : splittedTime?.[0]} : ${minutes != 0 ? minutes : '00'}` : ''
  return hours
}


// to identifiy the type of the licence number

export const IdentifyLicenseNumber = (licenseNumber) => {
  const license_number = licenseNumber?.toUpperCase()
  if (license_number?.length === 9) {
    const alpha = license_number?.slice(0, 1)
    const number = license_number?.slice(1, 9)
    if (/^[a-zA-Z]+$/.test(alpha) && !/^[a-zA-Z]+$/.test(number)) {
      return 'Resident'
    } else {
      return 'Non-resident'
    }
  } else if (license_number !== '' && license_number?.length >= 7) {
    return 'Non-resident'
  } else {
    return ''
  }
}

export const notify = (type, message, heading = '') => {
  let messagePass = <div><h4>{heading}</h4><p>{message}</p></div>
  toast.dismiss()
  if (type === 'error') {
    toast.error(messagePass, {
      position: toast.POSITION.TOP_RIGHT
    })
  } else if (type === 'success') {
    toast.success(messagePass, {
      position: toast.POSITION.TOP_RIGHT
    })
  }
}

export const phoneMasker = (phone) => {

  if (phone && phone.length >= 10) {
    let strlen = phone.length
    let start = strlen - 10
    let result = phone.slice(start, strlen)
    var USNumber = result.match(/(\d{3})(\d{3})(\d{4})/)
    return USNumber = USNumber ? '(' + USNumber[1] + ') ' + USNumber[2] + '-' + USNumber[3] : '-'
  } else {
    return '-'
  }

}
export const messageExtendSuccessPayment = 'Thank you for Parking with Us. Your Parking has been extended and ticket is sent to the registered Phone Number.'
export const messageSuccessPayment = 'Thank you for Parking with Us. Your e-Ticket details has been sent to the registered Phone Number.'
export const errorMessagePaymentFailed = 'Something went wrong. Please check your network connection and try again in some time. If your card is already charged, then please contact our support team.'

export const TimeConversion = (timeDuration) => {
  const daystoHours = Number(timeDuration?.days) * 24
  const minutestoHours = Number(timeDuration?.minutes) / 60
  const totalHours = Number(daystoHours) + Number(timeDuration?.hours) + Number(minutestoHours)
  return totalHours
}

export const getFieldValue = (name, e) => {
  return { target: { name: name, value: e } }
}
export const getCardIcon = (type) => {

  const cardType = type?.toLowerCase()

  switch (cardType) {
    case 'visa':
      return visa
    case 'vs':
      return visa
    case 'mastercard':
      return master
    case 'mastercardpng':
      return masterimg
    case 'mc':
      return master
    case 'm/c':
      return master
    case 'discover':
      return discover
    case 'dinersclub':
      return diner
    case 'americanexpress':
      return amex
    case 'amex':
      return amex
    case 'jcb':
      return jcb
    case 'gpl':
      return gpl
    case 'apl':
      return apl
    default:
      return blank
  }
}

export const emailValidation = (value) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
}

export const getBreakUpDetails = (paymentData) => {
  let listItem = []
  if (paymentData?.parking_amount && (paymentData?.parking_amount != '0.00' || paymentData?.is_price_applicable == '1')) {
    listItem = [...listItem, { 'headerName': 'Parking Amount', 'val': `$${paymentData?.parking_amount ? Number(paymentData?.parking_amount).toFixed(2) : '0.00'}` }]
  }

  if ((paymentData?.paid_amount && paymentData?.paid_amount !== '' && (Number(paymentData?.paid_amount) > 0))) {
    listItem = [...listItem, { 'headerName': 'Validated Amount', 'val': paymentData?.paid_amount && Number(paymentData?.paid_amount) > 0 ? `(-) $${Number(paymentData?.paid_amount)?.toFixed(2)}` : '$0.00' }]
  }

  // if (paymentData?.discount_amount != '' && paymentData?.discount_amount != null) {
  //   listItem = [...listItem, { 'headerName': 'Discount Amount', 'val': `$${paymentData?.discount_amount != '' ? paymentData?.discount_amount : '-'}` }]
  // }

  // if ((paymentData?.discount_hours && paymentData?.discount_hours != '') || (paymentData?.discount_amount && paymentData?.discount_amount != '' && Number(paymentData?.discount_amount) > 0)) {
  //   listItem = [...listItem, { 'headerName': paymentData?.discount_hours ? `Validated ${paymentData?.discount_hours} Hrs Free` : '-', 'val': `- $${paymentData?.discount_hours ? paymentData?.discount_hours : '-'}` }]
  // }

  if (paymentData?.amount_paid && paymentData?.amount_paid !== '' && Number(paymentData?.amount_paid) > 0 && Number(paymentData?.payable_amount) > 0) {
    listItem = [...listItem, { 'headerName': 'Amount Paid', 'val': `(-) $${paymentData?.amount_paid ? Number(paymentData?.amount_paid)?.toFixed(2) : 0}` }]
  }


  if (paymentData?.overstay_amount && paymentData?.overstay_amount !== '' && paymentData?.overstay_amount != '0.00' && Number(paymentData?.overstay_amount) > 0) {
    listItem = [...listItem, { 'headerName': 'Overstay Amount', 'val': `$${paymentData?.overstay_amount ? Number(paymentData?.overstay_amount).toFixed(2) : 0}` }]
  }

  if ((paymentData?.discount_hours && paymentData?.discount_hours != '') || (paymentData?.discount_amount && paymentData?.discount_amount != '' && (Number(paymentData?.discount_amount) > 0)) || ((paymentData?.promocode_discount_hours && paymentData?.promocode_discount_hours != '') || (paymentData?.promocode_discount_amount && paymentData?.promocode_discount_amount != '' && (Number(paymentData?.promocode_discount_amount) > 0)))) {
    listItem = [...listItem, { 'headerName': (paymentData?.discount_hours || paymentData?.promocode_discount_hours) ? `Validated Amount (${paymentData?.discount_hours ? paymentData?.discount_hours : paymentData?.promocode_discount_hours} Hrs Free)` : 'Discount Amount', 'val': (paymentData?.discount_amount && Number(paymentData?.discount_amount) > 0) ? `(-) $${Number(paymentData?.discount_amount)?.toFixed(2)}` : (paymentData?.promocode_discount_amount && Number(paymentData?.promocode_discount_amount) > 0) ? `(-) $${Number(paymentData?.promocode_discount_amount)?.toFixed(2)}` : '$0.00' }]
  }

  if ((paymentData?.processing_fee && paymentData?.processing_fee != '0.00' && (paymentData?.is_overstay != 1 || paymentData?.is_extended != 1)) || paymentData?.is_price_applicable == '1') {
    listItem = [...listItem, { 'headerName': 'Processing Fee', 'val': `$${paymentData?.processing_fee ? Number(paymentData?.processing_fee)?.toFixed(2) : '0.00'}` }]
  }

  if ((paymentData?.surcharge_fee && paymentData?.surcharge_fee != '0.00') || paymentData?.is_price_applicable == '1') {
    listItem = [...listItem, { 'headerName': 'City Surcharge', 'val': `$${paymentData?.surcharge_fee ? Number(paymentData?.surcharge_fee).toFixed(2) : '0.00'}` }]
  }

  if (paymentData?.facility?.facility_configuration?.is_overnight_hourly_enabled == '1' && (paymentData?.CCFee && (paymentData?.is_overstay != 1 || paymentData?.is_extended != 1)) || (paymentData?.is_price_applicable == '1' || Number(paymentData?.CCFee) > 0)) {
    listItem = [...listItem, { 'headerName': 'CC fee', 'val': `$${paymentData?.CCFee ? Number(paymentData?.CCFee).toFixed(2) : '0.00'}` }]
  }

  if (((paymentData?.tax_rate && paymentData?.tax_rate != '0.00') || (paymentData?.tax_fee && paymentData?.tax_fee != '0.00')) || paymentData?.is_price_applicable == '1') {
    listItem = [...listItem, { 'headerName': 'Tax', 'val': `$${paymentData?.tax_rate ? Number(paymentData?.tax_rate).toFixed(2) : paymentData?.tax_fee ? Number(paymentData?.tax_fee).toFixed(2) : '0.00'}` }]
  }


  return listItem

}
// export const getBreakUpDetails = (paymentData) => {
//   let listItem = []

//   if (paymentData?.parking_amount && paymentData?.parking_amount != '0.00') {
//     listItem = [...listItem, { 'headerName': 'Parking Amount', 'val': `$${paymentData?.parking_amount ? Number(paymentData?.parking_amount).toFixed(2) : '0.00'}` }]
//   }
//   if (paymentData?.processing_fee && paymentData?.processing_fee != '0.00' && paymentData?.parking_amount != '0.00' && Number(paymentData?.parking_amount) > 0) {
//     listItem = [...listItem, { 'headerName': 'Processing Fee', 'val': `$${paymentData?.processing_fee ? paymentData?.processing_fee : '0.00'}` }]
//   }

//   if (((paymentData?.tax_rate && paymentData?.tax_rate != '0.00') || (paymentData?.tax_fee && paymentData?.tax_fee != '0.00')) && paymentData?.parking_amount != '0.00' && Number(paymentData?.parking_amount) > 0) {
//     listItem = [...listItem, { 'headerName': 'Tax', 'val': `$${paymentData?.tax_rate ? Number(paymentData?.tax_rate).toFixed(2) : paymentData?.tax_fee ? Number(paymentData?.tax_fee).toFixed(2) : '0.00'}` }]
//   }

//   if (paymentData?.paid_amount && paymentData?.paid_amount !== '' && Number(paymentData?.paid_amount) > 0) {
//     listItem = [...listItem, { 'headerName': 'Validated Amount', 'val': `- $${paymentData?.paid_amount ? Number(paymentData?.paid_amount)?.toFixed(2) : 0}` }]
//   }

//   if ((paymentData?.discount_hours && paymentData?.discount_hours != '') || (paymentData?.discount_amount && paymentData?.discount_amount != '' && Number(paymentData?.discount_amount) > 0)) {
//     listItem = [...listItem, { 'headerName': paymentData?.discount_hours ? `Validated ${paymentData?.discount_hours} Hrs Free` : 'Discount Amount', 'val': `- $${paymentData?.discount_amount ? Number(paymentData?.discount_amount)?.toFixed(2) : '0.00'}` }]
//   }

//   // if (paymentData?.amount_paid && paymentData?.amount_paid !== '' && Number(paymentData?.amount_paid) > 0 && Number(paymentData?.payable_amount) > 0) {
//   //   listItem = [...listItem, { 'headerName': 'Amount Paid', 'val': `- $${paymentData?.amount_paid ? Number(paymentData?.amount_paid)?.toFixed(2) : 0}` }]
//   // }

//   if (paymentData?.overstay_amount && paymentData?.overstay_amount !== '' && paymentData?.overstay_amount != '0.00' && Number(paymentData?.overstay_amount) > 0) {
//     listItem = [...listItem, { 'headerName': 'Overstay Amount', 'val': `$${paymentData?.overstay_amount ? Number(paymentData?.overstay_amount).toFixed(2) : 0}` }]
//   }

//   // if (paymentData?.discount_amount && paymentData?.discount_amount != '' && Number(paymentData?.discount_amount) > 0) {
//   //   listItem = [...listItem, { 'headerName': paymentData?.discount_hours ? `Validated ${paymentData?.discount_hours} Hrs Free` : 'Discount Amount', 'val': `- $${paymentData?.discount_amount ? Number(paymentData?.discount_amount)?.toFixed(2) : 0}` }]
//   // }



//   return listItem

// }
//old function
// export const getBreakUpDetails = (paymentData) => {
//   let listItem = []

//   if (paymentData?.parking_amount && paymentData?.parking_amount != '0.00') {
//     listItem = [...listItem, { 'headerName': 'Parking Amount', 'val': `$${paymentData?.parking_amount ? Number(paymentData?.parking_amount).toFixed(2) : '0.00'}` }]
//   }
//   if (paymentData?.processing_fee && paymentData?.processing_fee != '0.00' && paymentData?.parking_amount != '0.00' && Number(paymentData?.parking_amount) > 0) {
//     listItem = [...listItem, { 'headerName': 'Processing Fee', 'val': `$${paymentData?.processing_fee ? paymentData?.processing_fee : '0.00'}` }]
//   }

//   if (((paymentData?.tax_rate && paymentData?.tax_rate != '0.00') || (paymentData?.tax_fee && paymentData?.tax_fee != '0.00')) && paymentData?.parking_amount != '0.00' && Number(paymentData?.parking_amount) > 0) {
//     listItem = [...listItem, { 'headerName': 'Tax', 'val': `$${paymentData?.tax_rate ? Number(paymentData?.tax_rate).toFixed(2) : paymentData?.tax_fee ? Number(paymentData?.tax_fee).toFixed(2) : '0.00'}` }]
//   }

//   if (paymentData?.paid_amount && paymentData?.paid_amount !== '' && Number(paymentData?.paid_amount) > 0) {
//     listItem = [...listItem, { 'headerName': 'Validated Amount', 'val': `- $${paymentData?.paid_amount ? Number(paymentData?.paid_amount)?.toFixed(2) : 0}` }]
//   }

//   if (paymentData?.discount_hours && paymentData?.discount_hours != '') {
//     listItem = [...listItem, { 'headerName': paymentData?.discount_hours ? `Validated ${paymentData?.discount_hours} Hrs Free` : '-', 'val': `- $${paymentData?.discount_hours ? paymentData?.discount_hours : '-'}` }]
//   }

//   if (paymentData?.amount_paid && paymentData?.amount_paid !== '' && Number(paymentData?.amount_paid) > 0 && Number(paymentData?.payable_amount) > 0) {
//     listItem = [...listItem, { 'headerName': 'Amount Paid', 'val': `- $${paymentData?.amount_paid ? Number(paymentData?.amount_paid)?.toFixed(2) : 0}` }]
//   }

//   if (paymentData?.overstay_amount && paymentData?.overstay_amount !== '' && paymentData?.overstay_amount != '0.00' && Number(paymentData?.overstay_amount) > 0) {
//     listItem = [...listItem, { 'headerName': 'Overstay Amount', 'val': `$${paymentData?.overstay_amount ? Number(paymentData?.overstay_amount).toFixed(2) : 0}` }]
//   }

//   if (paymentData?.discount_amount && paymentData?.discount_amount != '' && Number(paymentData?.discount_amount) > 0) {
//     listItem = [...listItem, { 'headerName': paymentData?.discount_hours ? `Validated ${paymentData?.discount_hours} Hrs Free` : 'Discount Amount', 'val': `- $${paymentData?.discount_amount ? Number(paymentData?.discount_amount)?.toFixed(2) : 0}` }]
//   }



//   return listItem

// }


export const isPromoValidateButton = (facilityData, conditionArray) => {
  // Check if is_promocode_validation_enabled's value is in the conditionArray
  const isPromocodeValidationEnabled = facilityData?.facility?.is_promocode_validation_enabled
  if (isPromocodeValidationEnabled !== undefined && conditionArray.includes(isPromocodeValidationEnabled)) {
    return true
  } else {
    return false
  }
}





export const getTotalOverstayPaidAmount = (paymentData) => {
  const totalPrice = paymentData && paymentData?.length > 0 ? paymentData?.map((item) => item?.grand_total ? item?.grand_total : 0).reduce((acc, total) => acc + Number(total), 0) : 0
  return Number(totalPrice).toFixed(2)
}

export const filterUnique = (array, property) => {
  return array?.filter((item, index, self) => {
    return self?.findIndex((t) => t[property] === item[property]) === index
  })
}

export const getSecondsLeft = (timeDifference, days, hours, minutes) => {
  const seconds = Math.floor(
    ((timeDifference % (1000 * 60 * 60)) / 1000) - (days * 24) - (hours * 60) - (minutes * 60)
  )
  return seconds
}

export const diff = (startTime, endTime) => {
  const startDate = new Date(startTime)
  const endDate = new Date(endTime)
  let timeDiff
  if (!isNaN(startDate) && !isNaN(endDate)) {
    const timeDifference = new Date(endDate) - new Date(startDate)
    // Calculate days, hours, and minutes
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    )
    //   const secondsLeft = getSecondsLeft(timeDifference, days, hours, minutes)
    let dayData = days > 0 ? ` ${days} ${days > 1 ? 'Days' : 'Day'}` : ''
    let hoursData =
      hours > 0 ? ` ${hours} ${hours > 1 ? 'Hours' : 'Hour'}` : ''
    // let minutesData = minutes > 0 ? ` ${secondsLeft > 0 ? minutes + 1 : minutes} Min` : ` ${secondsLeft > 0 ? minutes + 1 : minutes} Min`
    let minutesData = minutes > 0 ? `${minutes} Min` : ''

    timeDiff = ` ${dayData} ${hoursData} ${minutesData}`
  } else {
    timeDiff = 'N/A'
  }
  return timeDiff
  // 4 Days 11 Hours 30 Min
}





export const isExtendButton = (facilityData, conditionArray) => {
  // Check if is_extend_allow's value is in the conditionArray
  const isPromocodeValidationEnabled = facilityData?.is_extend_allow
  if (isPromocodeValidationEnabled !== undefined && conditionArray.includes(isPromocodeValidationEnabled)) {
    return true
  } else {
    return false
  }
}

export const isCheckoutButton = (facilityData, conditionArray) => {
  // Check if is_checkout_enabled's value is in the conditionArray
  const isPromocodeValidationEnabled = facilityData?.is_checkout_enabled
  if (isPromocodeValidationEnabled !== undefined && conditionArray.includes(isPromocodeValidationEnabled)) {
    return true
  } else {
    return false
  }
}

export const getDeviceType = () => {
  // Find if the device is IOS or Android/General
  let userAgent = navigator.userAgent || navigator.vendor
  const deviceType = (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) || /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    ? true : false
  return deviceType
}


export const getMobileOS = () => {
  const ua = navigator.userAgent
  if (/android/i.test(ua)) {
    return 'Android'
  }
  else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
    return 'iOS'
  }
  return 'Other'
}

export const getConvertedDate = (date) => {
  const deviceType = getDeviceType()
  let date_final

  const dateNew = moment(date, 'YYYY-MM-DD HH:mm:ss A').format('YYYY-MM-DD HH:mm:ss')

  if (deviceType) {
    let arr = dateNew.split(/[- :]/)
    const newDate = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    )
    date_final = newDate
  } else {
    date_final = dateNew
  }

  return date_final
}


export const convertNumDouble = (timer) => {
  if (!Number(timer).isNaN && (Number(timer) < 10 && Number(timer) > 0)) {
    return '0' + timer
  } else {
    return timer
  }
}

export const TimeConversionInHours = (timeDuration) => {
  const hours = Math.floor(timeDuration / 60)
  const minutes = timeDuration % 60
  return `${Number(hours) < 10 ? '0' + hours : hours}.${Number(minutes) < 10 ? '0' + minutes : minutes}`
}

export const MultiSelectWeekDays = [
  {
    'value': '1',
    'label': 'Sunday',
  },
  {
    'value': '2',
    'label': 'Monday',
  },
  {
    'value': '3',
    'label': 'Tuesday',
  },
  {
    'value': '4',
    'label': 'Wednesday',
  },
  {
    'value': '5',
    'label': 'Thursday',
  },
  {
    'value': '6',
    'label': 'Friday',
  },
  {
    'value': '7',
    'label': 'Saturday',
  }
]

export const commaSeperatedDays = (days) => {
  const dayValues = days.split(',').map(day => parseInt(day))
  let sortedDays = []

  for (let i = 2; i <= MultiSelectWeekDays.length + 1; i++) {
    let index = i % MultiSelectWeekDays.length
    if (index === 0) index = MultiSelectWeekDays.length
    if (dayValues.includes(index)) {
      sortedDays.push(MultiSelectWeekDays[index - 1].label.substring(0, 3))
    }
  }
  return sortedDays.join(', ')
}

export const calculateNextDayTimeIndication = (currentTime) => {
  // Parse the current time string into hours, minutes, and seconds
  const [hours, minutes, seconds] = currentTime.split(':').map(Number)

  // Calculate total seconds
  let totalSeconds = (hours * 3600) + (minutes * 60) + seconds

  // Determine if it's today or next day
  const indication = totalSeconds >= 86400 ? 'next day' : 'today'
  // Check if the total seconds exceed 24 hours
  if (totalSeconds >= 86400) {
    totalSeconds -= 86400 // Subtract 24 hours (86400 seconds) to wrap around to the next day
  }

  // Calculate new time components
  let nextDayHours = Math.floor(totalSeconds / 3600)
  let nextDayMinutes = Math.floor((totalSeconds % 3600) / 60)
  let nextDaySeconds = totalSeconds % 60

  // Format the next day time
  const nextDayTime = `${String(nextDayHours).padStart(2, '0')}:${String(nextDayMinutes).padStart(2, '0')}:${String(nextDaySeconds).padStart(2, '0')}`


  return { indication, nextDayTime }
}

export const mergeSubsequentDays = (commaSeparatedDays) => {
  const daysArray = commaSeparatedDays.split(', ')
  let mergedDays = []
  let startDay = ''
  let endDay = ''
  if (daysArray.length == 7) {
    return 'All Days'
  } else {
    for (let i = 0; i < daysArray.length; i++) {
      let currentDay = daysArray[i]
      let currentIndex = getDayIndex(currentDay)

      if (startDay === '') {
        startDay = currentDay
        endDay = currentDay
      } else {
        let endDayIndex = getDayIndex(endDay)
        if ((currentIndex === endDayIndex + 1) || (endDayIndex === 6 && currentIndex === 0)) {
          endDay = currentDay
        } else {
          if (startDay !== endDay) {
            if (getDayIndex(startDay) === getDayIndex(endDay) - 1) {
              mergedDays.push(startDay)
              mergedDays.push(endDay)
            } else {
              mergedDays.push(`${startDay} - ${endDay}`)
            }
          } else {
            mergedDays.push(startDay)
          }
          startDay = currentDay
          endDay = currentDay
        }
      }
    }

    if (startDay !== endDay) {
      if (getDayIndex(startDay) === getDayIndex(endDay) - 1) {
        mergedDays.push(startDay)
        mergedDays.push(endDay)
      } else {
        mergedDays.push(`${startDay} - ${endDay}`)
      }
    } else {
      mergedDays.push(startDay)
    }

    return mergedDays.join(', ')
  }
}


export const getDayIndex = (day) => {
  return MultiSelectWeekDays.findIndex(item => item.label.substring(0, 3) === day)
}

export const validExpiryDate = (value) => {
  let expiryDateCheck = value.length == 4 && value.substring(0, 2) < 13 && (value.substring(0, 2) >= moment(new Date()).format('MM') && value.substring(2) >= moment(new Date()).format('YY')
    || value.substring(0, 2) <= moment(new Date()).format('MM') && value.substring(2) > moment(new Date()).format('YY')
  )
  return expiryDateCheck
}
export const validFiservExpiryDate = (expiry) => {
  if (!expiry) return false

  const value = String(expiry).trim()

  // Must be 5 or 6 digits: YYYY(M)M
  if (!/^\d{5,6}$/.test(value)) return false

  const year = parseInt(value.slice(0, 4), 10)
  const month = parseInt(value.slice(4), 10) // take rest as month (1 or 2 digits)

  if (month < 1 || month > 12) return false

  const now = new Date()
  const currentYear = now.getFullYear()
  const currentMonth = now.getMonth() + 1

  if (year < currentYear) return false
  if (year === currentYear && month < currentMonth) return false

  return true
}



export const fullDayTimeSlot = [
  { name: '12:00 AM', val: '00:00:00' }, { name: '1:00 AM', val: '01:00:00' }, { name: '2:00 AM', val: '02:00:00' }, { name: '3:00 AM', val: '03:00:00' },
  { name: '4:00 AM', val: '04:00:00' }, { name: '5:00 AM', val: '05:00:00' }, { name: '6:00 AM', val: '06:00:00' }, { name: '7:00 AM', val: '07:00:00' },
  { name: '8:00 AM', val: '08:00:00' }, { name: '9:00 AM', val: '09:00:00' }, { name: '10:00 AM', val: '10:00:00' }, { name: '11:00 AM', val: '11:00:00' },
  { name: '12:00 PM', val: '12:00:00' }, { name: '1:00 PM', val: '13:00:00' }, { name: '2:00 PM', val: '14:00:00' }, { name: '3:00 PM', val: '15:00:00' },
  { name: '4:00 PM', val: '16:00:00' }, { name: '5:00 PM', val: '17:00:00' }, { name: '6:00 PM', val: '18:00:00' }, { name: '7:00 PM', val: '19:00:00' },
  { name: '8:00 PM', val: '20:00:00' }, { name: '9:00 PM', val: '21:00:00' }, { name: '10:00 PM', val: '22:00:00' }, { name: '11:00 PM', val: '23:00:00' }
]


export const AllowededTime = (permit_rate_criteria) => {
  const { indication, nextDayTime } = calculateNextDayTimeIndication(permit_rate_criteria?.entry_time_end)
  let commaSepDays = commaSeperatedDays(permit_rate_criteria.days)
  let subSequent = mergeSubsequentDays(commaSepDays)
  let entryBeginToExitEnd = `${fullDayTimeSlot.find((car) => car.val == permit_rate_criteria?.entry_time_begin)?.name} - ${(nextDayTime == '23:59:59') ? '11:59 PM' : (fullDayTimeSlot.find((car) => car.val == nextDayTime).name)} ${(indication == 'today') ? '' : `(${indication})`}`
  let tooltipText = `${subSequent} - ${entryBeginToExitEnd}`
  return tooltipText
}
export const getDiffFromTwoTime = (endTime, screen) => {
  let facilityTimeZone = 'America/New_York'
  if (screen == 'extend') {
    const data = JSON?.parse(localStorage?.getItem('ExtendData'))
    facilityTimeZone = data?.facility?.timezone || 'America/New_York'
  } else {
    const data = JSON.parse(localStorage?.getItem('paymentRecipt'))
    facilityTimeZone = data?.facility?.timezone || 'America/New_York'
  }
  let now = new Date(moment(new Date()).tz(facilityTimeZone).format('YYYY-MM-DD HH:mm:ss'))
  const timeDiff = moment(endTime).diff(now, 'minutes')
  return timeDiff
}

// for the Permit Parking Time fucntion

export const perkingParkingTime = (selectedPermit, isBorderHide) => {
  return (<p className='small m-0'>
    <label>Permit Parking Time : </label> <br />
    {(selectedPermit?.permit_rate_criteria_mapping?.length > 0) && selectedPermit?.permit_rate_criteria_mapping?.map((item, index) =>
      <span className={`${(isBorderHide) ? 'd-block' : 'd-inline-block border-end pe-2 me-2'}`} key={index} > {item?.permit_rate_criteria ? AllowededTime(item?.permit_rate_criteria) : 'N/A'}  </span>
    )
    }
  </p >)
}

export const perkingParkingTimeAccount = (selectedPermit, isBorderHide) => {
  return (<div className='text-md-end d-flex flex-column  justify-content-end '>
    <b className='fw-bold d-block small  '><i className='fa fa-clock'></i> Permit Time</b>
    {(selectedPermit?.permit_rate_criteria_mapping?.length > 0) && selectedPermit?.permit_rate_criteria_mapping?.map((item, index) =>
      <span className={` small ${(isBorderHide) ? 'd-block' : 'block '}`} key={index} > {item?.permit_rate_criteria ? AllowededTime(item?.permit_rate_criteria) : 'N/A'}  </span>
    )
    }
  </div >)
}


export const formDataToJson = (formData) => {

  const formObject = {}
  formData.forEach((value, key) => {
    // Check if the key already exists
    if (!Object.prototype.hasOwnProperty.call(formObject, key)) {
      formObject[key] = value
      return
    }
    // If the key exists and it's not an array, convert it to an array
    if (!Array.isArray(formObject[key])) {
      formObject[key] = [formObject[key]]
    }
    // Add the new value to the array
    formObject[key].push(value)
  })
  return formObject
}

export const handlingPermitServiceCriteria = (data) => {
  if (data?.length > 0) {
    const fixedObject = Object.keys(data?.[0]?.criteria).length > 0 ? data?.[0]?.criteria : null
    // Parse the time string
    const time_begin = moment(fixedObject?.entry_time_begin, 'HH:mm:ss')
    const time_end = moment(fixedObject?.exit_time_end, 'HH:mm:ss')

    // Format the time into hours and minutes
    const formattedTime = `(${time_begin?.format('hh:mm A')} - ${time_end?.format('hh:mm A')})`
    return formattedTime
  } else {
    return ''
  }
}


export const getDisclaimerNote = (facility, partner) => {
  let facilitytname = facility?.split('-')
  return (facility && facility != '' && partner?.company_name && partner?.company_name != '') ? <div className="alert alert-info mt-3 rounded border border-info" style={{ 'font-size': '12px' }}><b style={{ 'font-size': '16px' }}>Important Information!</b> <p>This reservation will entitle you to park anywhere on the <b>{facilitytname ? facilitytname?.[0] : ''}</b> subject to the parking rules and time restrictions for each individual parking lot.</p>
    <p>This reservation does not entitle you to park on any other <b>{partner?.company_name}</b>.  Parking on another campus does require you to create a separate reservation or parking session on that campus.</p>
  </div> : null
}

export const getQuerySearchParams = (queryName) => {
  const location = useLocation()
  let urlParams = new URLSearchParams(location?.search)
  const myParam = urlParams?.get(queryName)
  return myParam
}

export const areDatesExactlyGivenMonthsApart = (date1, date2, diffInMonths = 100) => {
  // Convert input to Date objects
  let d1 = new Date(date1)
  let d2 = new Date(date2)
  if (iOS) {
    d1 = getConvertedDate(date1)
    d2 = getConvertedDate(date2)
  }
  // Ensure dates are in order (d1 is earlier)
  if (d1 > d2) {
    [d1, d2] = [d2, d1]
  }


  // Calculate the number of days between d1 and d2
  const timeDifferenceInMs = d2 - d1 // milliseconds difference
  const daysDifference = timeDifferenceInMs / (1000 * 60 * 60 * 24)

  // Add diffInMonths months to d1
  const xMonthsLater = new Date(d1)
  xMonthsLater?.setMonth(xMonthsLater?.getMonth() + Number(diffInMonths))

  // Calculate the exact number of days from d1 to diffInMonths
  const exactXMonthsDifferenceInMs = xMonthsLater - d1
  const exactXMonthsDifferenceInDays = exactXMonthsDifferenceInMs / (1000 * 60 * 60 * 24)

  // Return true if daysDifference is less than diffInMonths
  return daysDifference <= exactXMonthsDifferenceInDays
}

export const disposeItem = (item) => {
  return item ? null : null
}

export const postionOfElement = (id) => {
  const offsets = document.getElementById(id).getBoundingClientRect()
  return offsets
}

export const restrictSpecialCharPromo = (e, allowSpaceHyphenFields = []) => {
  // List of restricted characters excluding numbers, alphabets, space, and hyphen
  const restrictedChars = [
    '!', '#', '^', '&', '~', '`', '*', ' ', '(', ')', '_', '=', '+',
    '[', ']', '{', '}', '\\', '|', ':', ';', '"', "'", '?', '.', ',', '>', '<'
  ]
  // Check if the current field is in the allowed fields array
  const isAllowedField = allowSpaceHyphenFields.includes(e.target.name)
  // Check if the pressed key is restricted
  const isRestricted = restrictedChars.includes(e.key) || e.keyCode === 220 || e.keyCode === 222
  // If it's a restricted character, or it's a space/hyphen in a field that's not allowed, prevent the input
  if (isRestricted || (!isAllowedField && (e.key === '-' || e.key === '@' || e.key === '$'))) {
    e.preventDefault()
  }
}

export const allowalphabetical = (event) => {
  // Use event.key for consistency and to support all input types (keyboard, scanner, mobile)
  const char = event.key
  handleKeyPressRestrictLeadingTrailingSpace(event)
  // Only allow single alphabetical chars and space, and prevent input of anything else
  if (!/^[a-zA-Z ]$/.test(char)) {
    event.preventDefault()
    return false
  }
  return true
}

export const allowAlphaNumericOnly = (e, isSpaceAllowed = false) => {
  const char = e.key
  if (isSpaceAllowed) {
    handleKeyPressRestrictLeadingTrailingSpace(e, false)
    // Only allow alphanumeric and space characters
    if (!/^[a-zA-Z0-9 ]$/.test(char)) {
      e.preventDefault()
      return false
    }
    return true
  } else {
    if (!/^[a-zA-Z0-9]$/.test(char)) {
      e.preventDefault()
      return false
    }
    return true
  }
}


export const hasDuplicateAnyKeyValues = (arr, keys) => {
  return keys.some(key => {
    const valuesSet = new Set()
    return arr.map(obj => (key in obj ? obj[key] : null))  // Check if key exists
      .filter(value => value !== null && value !== '')  // Ignore missing key values
      .some(value => {
        if (valuesSet.has(value.toUpperCase())) {
          return true  // Duplicate found
        }
        valuesSet.add(value.toUpperCase())  // Add the value to the set
        return false
      })
  })
}

export const toCamelCase = (str) => {
  return str
  // return str
  //   .split(' ')                     // Split the string into an array of words
  //   .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())  // Capitalize first letter of each word
  //   .join(' ')                     // Join the words back into a single string
}

export const removeDubleComma = (str) => {
  return str?.replace(/^"|"$/g, '')
}

export const trimObjectValues = (obj) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (typeof value == 'string') {
      const trimmedValue = value.trim()
      acc[key] = trimmedValue === '' ? undefined : trimmedValue
    } else {
      acc[key] = value // Keep non-string values unchanged
    }
    return acc
  }, {})
}

export const universityUploadHandler = (event, fileId, setUniversityidProof, universityidProof, universityidErrProof) => {
  let fileInput = false
  let file = document.getElementById(fileId).files[0]
  // let file = e.target.files[0]
  //if need to file compress this code is comment
  if (file) {
    if (file?.size <= 10 * (1048576)) {
      fileInput = file && (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')
      if (fileInput) {
        setUniversityidProof({ ...universityidProof, ...{ ['uploadFile']: file } })
        universityidErrProof({ ...universityidProof, ...{ ['uploadFile']: file } })
      } else {
        notify('error', 'Please upload a valid file type')
      }
    } else {
      if (file?.size) {
        notify('error', 'Please upload a file smaller than 10 MB')
      }
    }
  }
}

export const getMultiTaxProcessingFeeDetails = (paymentData) => {
  let listItem = []
  // if (paymentData?.is_prorate_apply && paymentData?.is_prorate_apply == '1' && paymentData?.permit_prorate != '0.00' && Number(paymentData?.permit_prorate) > 0) {
  //   listItem = [...listItem, { 'headerName': 'Permit Amount ', 'val': `$${paymentData?.permit_prorate ? Number(paymentData?.permit_prorate).toFixed(2) : 0}` }]
  // }else if(paymentData?.permit_rate?.rate){
  //   listItem = [...listItem, { 'headerName': 'Permit Amount', 'val': `$${paymentData?.permit_rate?.rate ? Number(paymentData?.permit_rate?.rate).toFixed(2) : 0}` }]
  // }

  if (paymentData?.fees && paymentData?.fees?.length) {
    let taxProcees = (paymentData?.fees && paymentData?.fees?.length > 0) ? ObjLooping(paymentData?.fees) : []
    listItem = [...listItem, ...taxProcees]
  }


  // if (paymentData?.permit_final_amount && paymentData?.permit_final_amount !== '' && Number(paymentData?.permit_final_amount) > 0) {
  //   listItem = [...listItem, { 'headerName': 'Total Price', 'val': `$${paymentData?.permit_final_amount ? Number(paymentData?.permit_final_amount)?.toFixed(2) : 0}` }]
  // }


  return listItem

}


export const ObjLooping = (array) => {
  let retArray = array?.map((res) => {
    return (
      {
        'headerName': res?.display_name, 'val': res?.amount ? '$' + Number(res?.amount)?.toFixed(2) : '$' + res?.amount
      }
    )
  })
  return retArray
}

export const shouldShowVehicleColumn = (vehicles, key) => {
  return vehicles?.some(v => {
    const val = v?.vehicle?.[key] || v?.[key]
    return val !== null && val !== undefined && val !== ''
  })
}

export const isVehicleLimitExceeded = (
  accessPermissions = [],
  currentTotalVehicles = 0,
  vehicleLimit = 0,
  includeEqual = true // true = block when equal, false = allow when equal
) => {
  const vehicleLimitEnabled = isPermissionExist(accessPermissions, 'Enable Vehicle Limit')

  if (!vehicleLimitEnabled || vehicleLimit <= 0) return false

  return includeEqual
    ? currentTotalVehicles >= vehicleLimit
    : currentTotalVehicles > vehicleLimit
}

// Function to check if the HTML is generating any visible Content or just Blank Tags
export function isHtmlRenderingVisibleContent(htmlString) {
  // Create a hidden container
  const container = document.createElement('div')
  container.style.position = 'absolute'
  container.style.left = '-9999px'
  container.style.top = '-9999px'
  container.style.visibility = 'hidden'

  // Inject the HTML
  container.innerHTML = htmlString
  document.body.appendChild(container)

  // Check if any visible content is rendered
  const hasVisibleText = container.textContent.trim().length > 0
  const hasRenderedDimensions = container.getBoundingClientRect().height > 0 &&
    container.getBoundingClientRect().width > 0

  // Cleanup
  document.body.removeChild(container)

  return hasVisibleText || hasRenderedDimensions
}
// export const showhideWalletButton = (facility) => {
//   const device = getDeviceType()
//   if (device && facility?.facility_configuration?.show_apple_pay_button == '1' && process.env.NODE_ENV === 'production' && window.location.protocol === 'https:') {
//     return true
//   } else if (!device && facility?.facility_configuration?.show_google_pay_button == '1' && ((process.env.NODE_ENV === 'production' && window.location.protocol === 'https:') || process.env.NODE_ENV === 'development')) {
//     return true
//   } else {
//     return false
//   }
// }

const checkButtonToShow = (arr = []) => {
  let res = true
  if (arr.length == 0) {
    return false
  }
  arr.map((item) => {
    if (item == '' || item == null || item == undefined) {
      res = false
    }
  })
  return res
}

export const showhideWalletButton = (facility) => {
  const device = getDeviceType()
  let buttonToShow = false
  if (facility?.facility_payment_details) {
    const { facility_payment_type_id, heartland_applepay_identifier, heartland_merchant_name, heartland_merchant_id, heartland_gpay_merchant,
      wallet_datacap_mid, datacap_script_url, wallet_datacap_token, wallet_datacap_ios_merchant, wallet_datacap_gpay_merchant, fiserv_env, fiserv_apple_merchant_identifier
    } = facility?.facility_payment_details || {}

    if (facility_payment_type_id == 4) {
      const loopArr = device ? [heartland_applepay_identifier, heartland_merchant_name] : [heartland_merchant_name, heartland_merchant_id, heartland_gpay_merchant]
      buttonToShow = checkButtonToShow(loopArr)
    } else if (facility_payment_type_id == 2) {
      const loopArr = device ? [wallet_datacap_mid, datacap_script_url, wallet_datacap_token, wallet_datacap_ios_merchant] : [wallet_datacap_token, wallet_datacap_mid, wallet_datacap_gpay_merchant, datacap_script_url]
      buttonToShow = checkButtonToShow(loopArr)
    } else if (facility_payment_type_id == 3) {
      const loopArr = device ? [fiserv_apple_merchant_identifier] : [fiserv_env]
      buttonToShow = checkButtonToShow(loopArr)
    }
  }

  if (device && facility?.facility_configuration?.show_apple_pay_button == '1' && buttonToShow && (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'development') && window.location.protocol === 'https:') {
    return true
  } else if (!device && facility?.facility_configuration?.show_google_pay_button == '1' && buttonToShow && ((process.env.NODE_ENV === 'production' && window.location.protocol === 'https:') || process.env.NODE_ENV === 'development')) {
    return true
  } else {
    return false
  }
}
export const isActivePermit = (data) => {
  let isActive = ((data.is_expired == 0 && data.cancelled_at == null && data.status == 1) || !moment(new Date()).isAfter(moment(data.grace_end_date), 'day')) ? true : false
  return isActive
}

export const clearAllLoginLocalStorage = () => {
  localStorage.removeItem('userData')
  localStorage.removeItem('isLoggedIn')
  localStorage.removeItem('masquerade')

  if (getPartnerDetails()) {
    sessionStorage.setItem('partnerSecret', getConfigDetails()?.CLIENT_SECRET)
    sessionStorage.setItem('partnerData', JSON.stringify(getPartnerDetails()))

  }
  localStorage.removeItem('partnerSecret')
  localStorage.removeItem('partnerData')

  sessionStorage.removeItem('partnerSecret')
  sessionStorage.removeItem('partnerData')

  // If you REALLY want to clear everything:
  // localStorage.clear()
  // sessionStorage.clear()
}

export const getAcceptedDocument = (documentType) => {
  switch (documentType) {
    case 'image':
      return 'image/*'
    case 'pdf':
      return '.pdf'
    case 'csv':
      return '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
    case 'image,pdf':
      return 'image/*, .pdf'
    case 'image,pdf,doc':
      return 'image/*, .pdf, .doc, .docx'
    case 'all':
      return 'image/*, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf, .doc, .docx'
    default:
      return 'image/*, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf, .doc, .docx'
  }
}

export const isValuePresentInArray = (array, item, key) => {
  for (const obj of array) {
    if (obj[key] === item) {
      return true
    }
  }
  return false
}

export const formatKeyInDocumentName = (string) => {
  const textWithoutUnderscore = string?.replace(/_/g, ' ')
  return textWithoutUnderscore?.charAt(0)?.toUpperCase() + textWithoutUnderscore?.slice(1)
}

export const getAcceptedFiles = (documentType) => {
  switch (documentType) {
    case 'image':
      return 'jpeg, jpg, png, svg'
    case 'pdf':
      return 'pdf'
    case 'csv':
      return 'csv/excel'
    case 'image,pdf':
      return 'jpeg, jpg, png, pdf'
    case 'image,pdf,doc':
      return 'jpeg, jpg, png, pdf, doc, docx'
    case 'all':
      return 'jpeg, jpg, png, pdf, excel, csv, doc, docx'
    default:
      return 'jpeg, jpg, png, pdf, excel, csv, doc, docx'
  }
}

export const safeNumber = (input = '', asString = false, afterDecimal = 2) => {
  if (typeof input !== 'string' && typeof input !== 'number') return null

  const cleaned = String(input)
    .replace(/,/g, '')
    .trim()

  const num = Number(cleaned)
  if (isNaN(num)) return null

  const fixed = num.toFixed(afterDecimal)
  return asString ? fixed : Number(fixed)
}

export const toBase64 = (str) => {
  return btoa(str)
}

export const validatorRule = {
  dropdown: {
    message: 'Please select your :attribute',
    rule: val => !validator.helpers.isBlank(val),
    required: true,
  },
  file_upload: {
    message: 'Please upload your image before starting the work.',
    rule: val => !validator.helpers.isBlank(val),
    required: true,
  },
  accepted: {
    message: 'The :attribute must be accepted.',
    rule: val => val === true,
    required: true,
  },
  after: {
    message: 'The :attribute must be after :date.',
    rule: (val, params) =>
      validator.helpers.momentInstalled() && moment.isMoment(val) && val.isAfter(params[0], 'day'),
    messageReplace: (message, params) => message.replace(':date', params[0].format('MM/DD/YYYY')),
  },
  after_or_equal: {
    message: 'The :attribute must be after or on :date.',
    rule: (val, params) =>
      validator.helpers.momentInstalled() &&
      moment.isMoment(val) &&
      val.isSameOrAfter(params[0], 'day'),
    messageReplace: (message, params) => message.replace(':date', params[0].format('MM/DD/YYYY')),
  },
  alpha: {
    message: 'The :attribute may only contain letters.',
    rule: val => validator.helpers.testRegex(val, /^[A-Z]*$/i),
  },
  alpha_space: {
    message: 'The :attribute may only contain letters and spaces.',
    rule: val => validator.helpers.testRegex(val, /^[A-Z\s]*$/i),
  },
  alpha_num: {
    message: 'The :attribute may only contain letters and numbers.',
    rule: val => validator.helpers.testRegex(val, /^[A-Z0-9]*$/i),
  },
  alpha_num_space: {
    message: 'The :attribute may only contain letters, numbers, and spaces.',
    rule: val => validator.helpers.testRegex(val, /^[A-Z0-9\s]*$/i),
  },
  alpha_num_dash: {
    message: 'The :attribute may only contain letters, numbers, and dashes.',
    rule: val => validator.helpers.testRegex(val, /^[A-Z0-9_-]*$/i),
  },
  alpha_num_dash_space: {
    message: 'The :attribute may only contain letters, numbers, dashes, and spaces.',
    rule: val => validator.helpers.testRegex(val, /^[A-Z0-9_\-\s]*$/i),
  },
  array: {
    message: 'The :attribute must be an array.',
    rule: val => Array.isArray(val),
  },
  before: {
    message: 'The :attribute must be before :date.',
    rule: (val, params) =>
      validator.helpers.momentInstalled() && moment.isMoment(val) && val.isBefore(params[0], 'day'),
    messageReplace: (message, params) => message.replace(':date', params[0].format('MM/DD/YYYY')),
  },
  before_or_equal: {
    message: 'The :attribute must be before or on :date.',
    rule: (val, params) =>
      validator.helpers.momentInstalled() &&
      moment.isMoment(val) &&
      val.isSameOrBefore(params[0], 'day'),
    messageReplace: (message, params) => message.replace(':date', params[0].format('MM/DD/YYYY')),
  },
  between: {
    message: 'The :attribute must be between :min and :max:type.',
    rule: (val, params) =>
      validator.helpers.size(val, params[2]) >= parseFloat(params[0]) &&
      validator.helpers.size(val, params[2]) <= parseFloat(params[1]),
    messageReplace: (message, params) =>
      message
        .replace(':min', params[0])
        .replace(':max', params[1])
        .replace(':type', validator.helpers.sizeText(params[2])),
  },
  boolean: {
    message: 'The :attribute must be a boolean.',
    rule: val => val === false || val === true,
  },
  card_exp: {
    message: 'The :attribute must be a valid expiration date.',
    rule: val => validator.helpers.testRegex(val, /^(([0]?[1-9]{1})|([1]{1}[0-2]{1}))\s?\/\s?(\d{2}|\d{4})$/),
  },
  card_num: {
    message: 'The :attribute must be a valid credit card number.',
    rule: val => validator.helpers.testRegex(val, /^\d{4}\s?\d{4,6}\s?\d{4,5}\s?\d{0,8}$/),
  },
  currency: {
    message: 'The :attribute must be a valid currency.',
    // Remove unnecessary escapes for $ and , in regex
    rule: val => validator.helpers.testRegex(val, /^[$Â£â‚¬Â¥]?(\d{1,3})(,?\d{3})*\.?\d{0,2}$/),
  },
  date: {
    message: 'The :attribute must be a date.',
    rule: val => validator.helpers.momentInstalled() && moment.isMoment(val),
  },
  date_equals: {
    message: 'The :attribute must be on :date.',
    rule: (val, params) =>
      validator.helpers.momentInstalled() &&
      moment.isMoment(val) &&
      val.isSame(params[0], 'day'),
    messageReplace: (message, params) => message.replace(':date', params[0].format('MM/DD/YYYY')),
  },
  email: {
    message: 'Please enter a valid email address.',
    rule: val =>
      validator.helpers.testRegex(
        val,
        /^[A-Z0-9.!#$%&'*+\-/=?^_`{|}~]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
      ),
  },
  in: {
    message: 'The selected :attribute must be :values.',
    rule: (val, params) => params.includes(val),
    messageReplace: (message, params) =>
      message.replace(':values', validator.helpers.toSentence(params)),
  },
  integer: {
    message: 'The :attribute must be an integer.',
    // Remove unnecessary escape for '-'
    rule: val => validator.helpers.testRegex(val, /^-?\d*$/),
  },
  max: {
    message: 'The :attribute may not be greater than :max:type.',
    rule: (val, params) => validator.helpers.size(val, params[1]) <= parseFloat(params[0]),
    messageReplace: (message, params) =>
      message.replace(':max', params[0]).replace(':type', validator.helpers.sizeText(params[1])),
  },
  min: {
    message: 'The :attribute must be at least :min:type.',
    rule: (val, params) => validator.helpers.size(val, params[1]) >= parseFloat(params[0]),
    messageReplace: (message, params) =>
      message.replace(':min', params[0]).replace(':type', validator.helpers.sizeText(params[1])),
  },
  not_in: {
    message: 'The selected :attribute must not be :values.',
    rule: (val, params) => !params.includes(val),
    messageReplace: (message, params) =>
      message.replace(':values', validator.helpers.toSentence(params)),
  },
  not_regex: {
    message: 'The :attribute must not match the required pattern.',
    rule: (val, params) =>
      !validator.helpers.testRegex(
        val,
        typeof params[0] === 'string' || params[0] instanceof String
          ? new RegExp(params[0])
          : params[0]
      ),
  },
  numeric: {
    message: 'The :attribute must be a number.',
    // Remove unnecessary escape for '-'
    rule: val => validator.helpers.testRegex(val, /^-?\d*\.?\d+$/),
  },
  phone: {
    message: 'Please enter a valid phone number.',
    rule: val => validator.helpers.testRegex(val.replace(/\D+/g, ''), validPhone),
  },
  regex: {
    message: 'The :attribute must match the required pattern.',
    rule: (val, params) =>
      validator.helpers.testRegex(
        val,
        typeof params[0] === 'string' || params[0] instanceof String
          ? new RegExp(params[0])
          : params[0]
      ),
  },
  required: {
    message: 'The :attribute is required.',
    rule: val => !validator.helpers.isBlank(val),
    required: true,
  },
  size: {
    message: 'The :attribute must be :size:type.',
    rule: (val, params) => validator.helpers.size(val, params[1]) === parseFloat(params[0]),
    messageReplace: (message, params) =>
      message.replace(':size', params[0]).replace(':type', validator.helpers.sizeText(params[1])),
  },
  string: {
    message: 'The :attribute must be a string.',
    rule: val => typeof val === 'string',
  },
  typeof: {
    message: 'The :attribute is not the correct type of :type.',
    rule: (val, params) => typeof val === typeof params[0],
    messageReplace: (message, params) => message.replace(':type', typeof params[0]),
  },
  url: {
    message: 'The website URL must be valid.',
    // eslint-disable-next-line no-shadow
    rule: (val, params, validator) => {
      return (
        validator.helpers.testRegex(
          val,
          /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/i
        ) && (!params || !params.includes(val))
      )
    },
  },
  zeroCheck: {
    message: 'The :attribute should be greater than zero.',
    rule: val => {
      // Parse the value to handle string or numeric inputs
      const value = parseFloat(val)
      // Check if the value is exactly 0 or 0.00
      return value !== 0
    },
  },
}

export const validator = new SimpleReactValidator({
  className: 'text-primary text-start mt-2',
  validators: validatorRule,
})

export const requiredDropdown = (validatorObj = {}, name = '', value = '', attribute = '', rule = 'required', requiredMessage = false) => {
  return validatorObj.message(name, value, rule, { messages: { required: requiredMessage ? attribute : `Please select your ${attribute}.` } })
}
export const requiredTextInput = (validatorObj = {}, name = '', value = '', attribute = '', rule = 'required') => {
  return validatorObj.message(name, value, rule, {
    messages: { required: `The ${attribute} field is required.` }
  })
}

export const reverseObj = (obj) => {
  let newObj = {}
  Object.keys(obj)
    .reverse()
    .forEach((key) => {
      newObj[key] = obj[key]
    })
  return newObj
}

export const validationElsePart = (validator) => {
  let validateFields = reverseObj(validator.fields)
  for (const property in validateFields) {
    if (!validateFields[property]) {
      document.getElementById(property).focus()
    }
  }
  validator.showMessages()
}


// Reusable validator handler
export const handleValidator = (validator, validFields = false, forceUpdate = null) => {
  // Use validFields array if not empty, otherwise use allValid()
  let isValid

  if (validFields && Array.isArray(validFields)) {
    isValid = validFields.every(field =>
      Object.prototype.hasOwnProperty.call(validator.current.fields, field)
        ? validator.current.fieldValid(field)
        : true
    )
  } else {
    isValid = validator.current.allValid()
  }
  if (isValid) {
    return true
  } else {
    // Focus on the first invalid field
    const validateFields = reverseObj(validator.current.fields)
    for (const property in validateFields) {
      if ((!validateFields[property] && property !== 'event')) {
        const element = document.getElementById(property)
        if (element) element.focus()
      }
    }
    validator.current.showMessages()
    // force a re-render to show the validation messages
    forceUpdate({})
    return false
  }
}

export const makeEmployerPayload = (emp) => ({
  name: emp?.employer_name || '',
  email: emp?.employer_email || '',
  phone: emp?.employer_phone || '',
  company_name: emp?.employer_company_name || '',
  address: emp?.employer_address1 || '',
  address2: emp?.employer_address2 || '',
  city: emp?.employer_city || '',
  state: emp?.employer_state || '',
  country: emp?.employer_country || '',
  pincode: emp?.employer_zipcode || '',
})

export const getEmployerDetails = (employerDetails = {}) => {
  const ed = employerDetails || {}
  if (!ed || !ed?.name) return []
  return [
    { label: 'Name', value: ed?.name || '-' },
    {
      label: 'Phone Number',
      value: ed?.phone && ed?.phone.length >= 10 ? phoneMasker(ed?.phone) : '-',
    },
    ed?.email && { label: 'Email', value: ed?.email },
    ed?.company_name && { label: 'Company Name', value: ed?.company_name },
    ed?.address && {
      label: 'Address Line 1',
      value: `${ed?.address}`.trim(),
    },
    ed?.address2 && {
      label: 'Address Line 2',
      value: `${ed?.address2 || ''}`.trim(),
    },
    { label: 'City', value: ed?.city || '-' },
    { label: 'State', value: ed?.state || '-' },
    { label: 'Country', value: ed?.country || '-' },
    { label: 'Zipcode', value: ed?.pincode || '-' },
  ].filter(Boolean)
}

export const employerDetailsSection = (details = {}, borderClass = false) => {
  const employerDetails = getEmployerDetails(details)
  return employerDetails.length > 0 ? (
    <div className={borderClass ? '' : 'border-top container py-2'}>
      {borderClass ? <div className="border border-dashed my-4 d-block w-100"></div> : null}
      <b>Employer Details</b>
      <div className="row g-1 row-cols-1 row-cols-sm-4">
        {employerDetails
          ?.filter(detail => detail?.value && detail?.value !== '-')
          ?.map((detail, idx) => (
            <div className="col" key={idx}>
              <small className="fw-bold text-muted d-block">
                {detail?.label}
              </small>
              <p className="m-0">{detail?.value}</p>
            </div>
          ))}
      </div>
    </div>
  ) : null
}


/**
 * Strips all (possibly-nested) HTML tags and whitespace to check if content is "empty".
 * It also removes typical empty paragraphs/divs/spans with or without spaces or &nbsp;
 * @param {string} html The HTML string to check
 * @returns {boolean} True if content is empty/meaningless, or False otherwise
 */
export const isHtmlContentEmpty = (html) => {
  if (!html) return true

  // Remove all tags and decode basic html entities.
  let stripped = html
  // Remove empty block tags (br, hr, etc), spans/divs/ps with only whitespace or &nbsp
  stripped = stripped.replace(/<(p|div|span)[^>]*>((\s|<br\s*\/?>|&nbsp;|&#160;|&#32;|&#xA0;)*)<\/\1>/gi, '')
  // Remove remaining tags
  stripped = stripped.replace(/<[^>]+>/g, '')
  // Replace HTML entities with nothing (leaving only real text)
  stripped = stripped.replace(/&nbsp;|&#160;|&#32;|&#xA0;/gi, '')
  // Remove whitespace
  stripped = stripped.replace(/\s+/g, '')
  // If all that's left is empty, declare it empty
  return stripped.length === 0
}

export const excludeKeysFromValidator = (validator, isCardFormVisible = false, formData, accessPermissions = []) => {
  const validatorFieldKeys = Object.keys(validator.current.fields)

  let keysToExclude = []

  let employerFields = ['employer_name', 'employer_phone']
  const cardKeysToExclude = ['name', 'card_pan', 'expiration_date', 'card_card_security_cvx_2'] // Add any other keys to exclude here

  if (!isCardFormVisible) {
    keysToExclude = keysToExclude.concat(cardKeysToExclude)
  }
  if (!(formData?.userAcknowledge)) {
    keysToExclude.push('tc_acceptance_signature')
  }

  let employerPermission = (isPermissionExist(accessPermissions, 'Display Employer Details') &&
    formData?.selFaclity?.facility_configuration?.permit_employer_name_enabled == '1' &&
    formData?.selectedPermitType?.[0]?.permit_rate?.[0]?.is_employer == '1')

  if (!employerPermission) {
    keysToExclude = keysToExclude.concat(employerFields)
  }

  // Defensive: Remove duplicates in keysToExclude (just in case)
  keysToExclude = [...new Set(keysToExclude)]

  // Remove excluded keys from validator.current.fields
  keysToExclude.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(validator.current.fields, key)) {
      delete validator.current.fields[key]
    }
  })

  const filteredValidatorFieldKeys = validatorFieldKeys.filter(
    key => !keysToExclude.includes(key)
  )
  return filteredValidatorFieldKeys
}

export function nullAndUndefindCheck(value) {
  if (value !== null && value !== undefined && value != 'undefined' && value != 'null' && value != '') {
    return value
  } else {
    return false
  }
}

export const getConfigPermission = (selectedFacilityData = {}, configPermission = '') => {
  const facilityConfiguration = (selectedFacilityData && selectedFacilityData?.facility_configuration) ? selectedFacilityData?.facility_configuration : {}
  const isConfigPermissionEnabled = (nullAndUndefindCheck(facilityConfiguration) && nullAndUndefindCheck(facilityConfiguration?.[configPermission]) && facilityConfiguration?.[configPermission] == '1') ? true : false
  return isConfigPermissionEnabled
}

export const isParksfo = () => {
  return window?.location?.toString().includes('parksfo')
}

export const truncateToAfterDecimal=(num) =>{//only allow 2 digit after decimal and no roundup after decimal EOS-1978
  let result =Number(Math.floor(num * 100) / 100)
  result=result.toFixed(2)
  return result
}

export const getPromoName = (priceDetails, promoRes) => {
  return (
    priceDetails?.applied_promo_code?.name ??
    priceDetails?.promocode_name ??
    promoRes?.promocode?.promocode_name ??
    (typeof priceDetails?.promocode === 'string'
      ? priceDetails.promocode
      : typeof priceDetails?.promocode?.promocode === 'string'
      ? priceDetails.promocode.promocode
      : priceDetails?.promocode?.promocode?.promocode_name)
  ) ?? null
}